import { INSPECTOR_PORTAL_TIMELINE_MAX_ITEMS } from "../constants";
import { ViewingsDispatchRequest } from "@/schemas";
import { FormattedMessage } from "react-intl";

const TIMELINE_MESSAGE_ID_PREFIX = "viewings.timeline.";

export default function ActivityTimeline({
  request,
}: {
  request: ViewingsDispatchRequest;
}) {
  return (
    <div className="rounded-md border bg-muted-background p-3">
      <p className="text-sm font-semibold text-primary">
        <FormattedMessage id="viewings.activityTimeline" />
      </p>
      <ul className="mt-2 space-y-1 text-xs text-muted-foreground">
        {request.activityTimeline
          .slice(0, INSPECTOR_PORTAL_TIMELINE_MAX_ITEMS)
          .map((item) => (
            <li key={item.id}>
              {item.at} - {item.actorName}:{" "}
              {item.action.startsWith(TIMELINE_MESSAGE_ID_PREFIX) ? (
                <FormattedMessage id={item.action} />
              ) : (
                item.action
              )}
            </li>
          ))}
      </ul>
    </div>
  );
}
